export const environment = {
  Inactivity_time: 60 * 60,
  PAGE_SIZE: 30,
  // Local
  // API_END_URL: "http://localhost:3001/api/v1",

  // Production
  API_END_URL: "https://api.bring-express.com/api/v1",
};
